import React,{useState,}from 'react'
import { Modal,Form,Input, Button,message} from 'antd';
import { useBnsMeiJieAddMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import GetUserDept from '../../cpn/GetUserDept';
import MediaDesc from './MediaDesc';
function MediaAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsMeiJieAddMutation()
    const [info,setInfo] = useState({
        bmj_content:'',
    });
    //返回详情
    const [openCheck, setopenCheck] = useState({id:'',open:false})
    return (
            <>
                <Button
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >新增</Button>
                <Modal
                    width={1000}
                    open={open}
                    title='新增媒介'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "bmj_dept_id" : info.bmj_dept_id,
                                    "bmj_dept_name" : info.bmj_dept_name,
                                    "bmj_e_id" : localStorage.getItem('e_id'),
                                    "bmj_name" : info.bmj_name,
                                    "bmj_content" : info.bmj_content,
                                    "bmj_cid" : localStorage.getItem('eu_id'),
                                    "bmj_cname" : localStorage.getItem('eu_name'),   
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                        setopenCheck({id:res.data.Result,open:true})    
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bmj_dept_id:e,bmj_dept_name:f}))
                            }}
                        />
                        <Form.Item name="name" label='名称' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bmj_name:e.target.value}))}}
                            />
                        </Form.Item>     
                        <Form.Item
                            label='备注'
                            wrapperCol={{span:20}}
                        >
                            <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,bmj_content:e}))}}/>
                        </Form.Item>    
                    </Form>
                </Modal>
                <Modal 
                    open={openCheck.open} 
                    onOk={() => {}} 
                    onCancel={() => {setopenCheck({open:false})}}
                    width={1200}
                    cancelText='关闭'
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <Button
                                onClick={() => {
                                    setopenCheck(false);
                                    setOpen(true)
                                }}
                            >再增一条</Button>
                            <CancelBtn />
                        </>
                    )}
                >
                    <MediaDesc
                        bmj_id={openCheck.id}
                    />
                </Modal> 
            </>
        )
}

export default MediaAdd